import * as React from 'react';

import NPIForm from './NPI';
import FBIMODForm from './FBIMOD';
import BNSQForm from './BNSQ';
import ADLForm from './ADL';
import IADLForm from './IADL';
import type { TDiagnosticSurveyDocumentType } from '../../utils';

const DiagnosticSurveyForm = ({ document }: IOwnProps): React.ReactNode => {
  if (!document) return null;
  switch (document._type) {
    case 'npi':
      return <NPIForm />;
    case 'fbimod':
      return <FBIMODForm />;
    case 'bnsq':
      return <BNSQForm />;
    case 'adl':
      return <ADLForm />;
    case 'iadl':
      return <IADLForm />;
    default:
      return null;
  }
};

interface IOwnProps {
  document: IDocumentWithTypeV2<TDiagnosticSurveyDocumentType> | undefined;
}

export default DiagnosticSurveyForm;
